import { Column } from 'primereact/column'
import { Dropdown } from 'primereact/dropdown'
import { InputNumber } from 'primereact/inputnumber'
import { InputText } from 'primereact/inputtext'
import { FC, useEffect, useRef, useState } from 'react'
import { useGetGroupForceData } from '../../api/report-API'
import { CompactTableHeaderClassName } from '../../utils/constants'
import ProjectRunSelector from './ProjectRunSelector'
import GroupForceChartPanel, { GroupForceChartConfig } from './GroupForceChartPanel'
import { toast } from 'react-hot-toast'
import { DataTable } from 'primereact/datatable'
import { set } from 'date-fns'

const KEY_DELIMITER = '::'
const KEY_GROUP_FORCE_CHARTS = 'group_force_charts'

const GROUP_TO_FIELD_MAP = {
  Body: [
    'delta_group_body_cd',
    'delta_group_body_cl',
    'delta_group_body_cs',
    'group_body_cd',
    'group_body_cl',
    'group_body_cs'
  ],
  Cockpit: [
    'delta_group_cockpit_cd',
    'delta_group_cockpit_cl',
    'delta_group_cockpit_cs',
    'group_cockpit_cd',
    'group_cockpit_cl',
    'group_cockpit_cs'
  ],
  'Engine Bay': [
    'delta_group_engine_bay_cd',
    'delta_group_engine_bay_cl',
    'delta_group_engine_bay_cs',
    'group_engine_bay_cd',
    'group_engine_bay_cl',
    'group_engine_bay_cs'
  ],
  Exhaust: [
    'delta_group_exhaust_cd',
    'delta_group_exhaust_cl',
    'delta_group_exhaust_cs',
    'group_exhaust_cd',
    'group_exhaust_cl',
    'group_exhaust_cs'
  ],
  'Front Wing': [
    'delta_group_fw_cd',
    'delta_group_fw_cl',
    'delta_group_fw_cs',
    'group_fw_cd',
    'group_fw_cl',
    'group_fw_cs'
  ],
  'Floor Bottom': [
    'delta_group_floor_bottom_cd',
    'delta_group_floor_bottom_cl',
    'delta_group_floor_bottom_cs',
    'group_floor_bottom_cd',
    'group_floor_bottom_cl',
    'group_floor_bottom_cs'
  ],
  'Floor Top': [
    'delta_group_floor_top_cd',
    'delta_group_floor_top_cl',
    'delta_group_floor_top_cs',
    'group_floor_top_cd',
    'group_floor_top_cl',
    'group_floor_top_cs'
  ],
  Intake: [
    'delta_group_intake_cd',
    'delta_group_intake_cl',
    'delta_group_intake_cs',
    'group_intake_cd',
    'group_intake_cl',
    'group_intake_cs'
  ],
  'Rear Wing': [
    'delta_group_rw_cd',
    'delta_group_rw_cl',
    'delta_group_rw_cs',
    'group_rw_cd',
    'group_rw_cl',
    'group_rw_cs'
  ],
  Restraints: [
    'delta_group_restraints_cd',
    'delta_group_restraints_cl',
    'delta_group_restraints_cs',
    'group_restraints_cd',
    'group_restraints_cl',
    'group_restraints_cs'
  ],
  'Susp LF Arms': [
    'delta_group_susp_lf_arms_cd',
    'delta_group_susp_lf_arms_cl',
    'delta_group_susp_lf_arms_cs',
    'group_susp_lf_arms_cd',
    'group_susp_lf_arms_cl',
    'group_susp_lf_arms_cs'
  ],
  'Susp LF OBD': [
    'delta_group_susp_lf_obd_cd',
    'delta_group_susp_lf_obd_cl',
    'delta_group_susp_lf_obd_cs',
    'group_susp_lf_obd_cd',
    'group_susp_lf_obd_cl',
    'group_susp_lf_obd_cs'
  ],
  'Susp LR Arms': [
    'delta_group_susp_lr_arms_cd',
    'delta_group_susp_lr_arms_cl',
    'delta_group_susp_lr_arms_cs',
    'group_susp_lr_arms_cd',
    'group_susp_lr_arms_cl',
    'group_susp_lr_arms_cs'
  ],
  'Susp LR OBD': [
    'delta_group_susp_lr_obd_cd',
    'delta_group_susp_lr_obd_cl',
    'delta_group_susp_lr_obd_cs',
    'group_susp_lr_obd_cd',
    'group_susp_lr_obd_cl',
    'group_susp_lr_obd_cs'
  ],
  'Susp RF Arms': [
    'delta_group_susp_rf_arms_cd',
    'delta_group_susp_rf_arms_cl',
    'delta_group_susp_rf_arms_cs',
    'group_susp_rf_arms_cd',
    'group_susp_rf_arms_cl',
    'group_susp_rf_arms_cs'
  ],
  'Susp RF OBD': [
    'delta_group_susp_rf_obd_cd',
    'delta_group_susp_rf_obd_cl',
    'delta_group_susp_rf_obd_cs',
    'group_susp_rf_obd_cd',
    'group_susp_rf_obd_cl',
    'group_susp_rf_obd_cs'
  ],
  'Susp RR Arms': [
    'delta_group_susp_rr_arms_cd',
    'delta_group_susp_rr_arms_cl',
    'delta_group_susp_rr_arms_cs',
    'group_susp_rr_arms_cd',
    'group_susp_rr_arms_cl',
    'group_susp_rr_arms_cs'
  ],
  'Susp RR OBD': [
    'delta_group_susp_rr_obd_cd',
    'delta_group_susp_rr_obd_cl',
    'delta_group_susp_rr_obd_cs',
    'group_susp_rr_obd_cd',
    'group_susp_rr_obd_cl',
    'group_susp_rr_obd_cs'
  ],
  'Tire Ramp LS': [
    'delta_group_tire_ramp_ls_cd',
    'delta_group_tire_ramp_ls_cl',
    'delta_group_tire_ramp_ls_cs',
    'group_tire_ramp_ls_cd',
    'group_tire_ramp_ls_cl',
    'group_tire_ramp_ls_cs'
  ],
  'Tire Ramp RS': [
    'delta_group_tire_ramp_rs_cd',
    'delta_group_tire_ramp_rs_cl',
    'delta_group_tire_ramp_rs_cs',
    'group_tire_ramp_rs_cd',
    'group_tire_ramp_rs_cl',
    'group_tire_ramp_rs_cs'
  ],
  Ungrouped: [
    'delta_group_ungrouped_cd',
    'delta_group_ungrouped_cl',
    'delta_group_ungrouped_cs',
    'group_ungrouped_cd',
    'group_ungrouped_cl',
    'group_ungrouped_cs'
  ]
}

const FIELD_TO_GROUP_MAP = {
  group_body_cd: { group: 'Body', position: -1, field: 'cd' },
  group_body_cl: { group: 'Body', position: -1, field: 'cl' },
  group_body_cs: { group: 'Body', position: -1, field: 'cs' },
  group_cockpit_cd: { group: 'Cockpit', position: -1, field: 'cd' },
  group_cockpit_cl: { group: 'Cockpit', position: -1, field: 'cl' },
  group_cockpit_cs: { group: 'Cockpit', position: -1, field: 'cs' },
  group_engine_bay_cd: { group: 'Engine Bay', position: -1, field: 'cd' },
  group_engine_bay_cl: { group: 'Engine Bay', position: -1, field: 'cl' },
  group_engine_bay_cs: { group: 'Engine Bay', position: -1, field: 'cs' },
  group_exhaust_cd: { group: 'Exhaust', position: -1, field: 'cd' },
  group_exhaust_cl: { group: 'Exhaust', position: -1, field: 'cl' },
  group_exhaust_cs: { group: 'Exhaust', position: -1, field: 'cs' },
  group_fw_cd: { group: 'Front Wing', position: -1, field: 'cd' },
  group_fw_cl: { group: 'Front Wing', position: -1, field: 'cl' },
  group_fw_cs: { group: 'Front Wing', position: -1, field: 'cs' },
  group_floor_bottom_cd: { group: 'Floor Bottom', position: -1, field: 'cd' },
  group_floor_bottom_cl: { group: 'Floor Bottom', position: -1, field: 'cl' },
  group_floor_bottom_cs: { group: 'Floor Bottom', position: -1, field: 'cs' },
  group_floor_top_cd: { group: 'Floor Top', position: -1, field: 'cd' },
  group_floor_top_cl: { group: 'Floor Top', position: -1, field: 'cl' },
  group_floor_top_cs: { group: 'Floor Top', position: -1, field: 'cs' },
  group_intake_cd: { group: 'Intake', position: -1, field: 'cd' },
  group_intake_cl: { group: 'Intake', position: -1, field: 'cl' },
  group_intake_cs: { group: 'Intake', position: -1, field: 'cs' },
  group_rw_cd: { group: 'Rear Wing', position: -1, field: 'cd' },
  group_rw_cl: { group: 'Rear Wing', position: -1, field: 'cl' },
  group_rw_cs: { group: 'Rear Wing', position: -1, field: 'cs' },
  group_susp_lf_arms_cd: { group: 'Susp LF Arms', position: -1, field: 'cd' },
  group_susp_lf_arms_cl: { group: 'Susp LF Arms', position: -1, field: 'cl' },
  group_susp_lf_arms_cs: { group: 'Susp LF Arms', position: -1, field: 'cs' },
  group_susp_lf_obd_cd: { group: 'Susp LF OBD', position: -1, field: 'cd' },
  group_susp_lf_obd_cl: { group: 'Susp LF OBD', position: -1, field: 'cl' },
  group_susp_lf_obd_cs: { group: 'Susp LF OBD', position: -1, field: 'cs' },
  group_susp_lr_arms_cd: { group: 'Susp LR Arms', position: -1, field: 'cd' },
  group_susp_lr_arms_cl: { group: 'Susp LR Arms', position: -1, field: 'cl' },
  group_susp_lr_arms_cs: { group: 'Susp LR Arms', position: -1, field: 'cs' },
  group_susp_lr_obd_cd: { group: 'Susp LR OBD', position: -1, field: 'cd' },
  group_susp_lr_obd_cl: { group: 'Susp LR OBD', position: -1, field: 'cl' },
  group_susp_lr_obd_cs: { group: 'Susp LR OBD', position: -1, field: 'cs' },
  group_susp_rf_arms_cd: { group: 'Susp RF Arms', position: -1, field: 'cd' },
  group_susp_rf_arms_cl: { group: 'Susp RF Arms', position: -1, field: 'cl' },
  group_susp_rf_arms_cs: { group: 'Susp RF Arms', position: -1, field: 'cs' },
  group_susp_rf_obd_cd: { group: 'Susp RF OBD', position: -1, field: 'cd' },
  group_susp_rf_obd_cl: { group: 'Susp RF OBD', position: -1, field: 'cl' },
  group_susp_rf_obd_cs: { group: 'Susp RF OBD', position: -1, field: 'cs' },
  group_susp_rr_arms_cd: { group: 'Susp RR Arms', position: -1, field: 'cd' },
  group_susp_rr_arms_cl: { group: 'Susp RR Arms', position: -1, field: 'cl' },
  group_susp_rr_arms_cs: { group: 'Susp RR Arms', position: -1, field: 'cs' },
  group_susp_rr_obd_cd: { group: 'Susp RR OBD', position: -1, field: 'cd' },
  group_susp_rr_obd_cl: { group: 'Susp RR OBD', position: -1, field: 'cl' },
  group_susp_rr_obd_cs: { group: 'Susp RR OBD', position: -1, field: 'cs' },
  group_tire_ramp_ls_cd: { group: 'Tire Ramp LS', position: -1, field: 'cd' },
  group_tire_ramp_ls_cl: { group: 'Tire Ramp LS', position: -1, field: 'cl' },
  group_tire_ramp_ls_cs: { group: 'Tire Ramp LS', position: -1, field: 'cs' },
  group_tire_ramp_rs_cd: { group: 'Tire Ramp RS', position: -1, field: 'cd' },
  group_tire_ramp_rs_cl: { group: 'Tire Ramp RS', position: -1, field: 'cl' },
  group_tire_ramp_rs_cs: { group: 'Tire Ramp RS', position: -1, field: 'cs' },
  group_restraints_cd: { group: 'Restraints', position: -1, field: 'cd' },
  group_restraints_cl: { group: 'Restraints', position: -1, field: 'cl' },
  group_restraints_cs: { group: 'Restraints', position: -1, field: 'cs' },
  group_ungrouped_cd: { group: 'Ungrouped', position: -1, field: 'cd' },
  group_ungrouped_cl: { group: 'Ungrouped', position: -1, field: 'cl' },
  group_ungrouped_cs: { group: 'Ungrouped', position: -1, field: 'cs' },
  delta_group_body_cd: { group: 'Body', position: -1, field: 'delta_cd' },
  delta_group_body_cl: { group: 'Body', position: -1, field: 'delta_cl' },
  delta_group_body_cs: { group: 'Body', position: -1, field: 'delta_cs' },
  delta_group_cockpit_cd: { group: 'Cockpit', position: -1, field: 'delta_cd' },
  delta_group_cockpit_cl: { group: 'Cockpit', position: -1, field: 'delta_cl' },
  delta_group_cockpit_cs: { group: 'Cockpit', position: -1, field: 'delta_cs' },
  delta_group_engine_bay_cd: { group: 'Engine Bay', position: -1, field: 'delta_cd' },
  delta_group_engine_bay_cl: { group: 'Engine Bay', position: -1, field: 'delta_cl' },
  delta_group_engine_bay_cs: { group: 'Engine Bay', position: -1, field: 'delta_cs' },
  delta_group_exhaust_cd: { group: 'Exhaust', position: -1, field: 'delta_cd' },
  delta_group_exhaust_cl: { group: 'Exhaust', position: -1, field: 'delta_cl' },
  delta_group_exhaust_cs: { group: 'Exhaust', position: -1, field: 'delta_cs' },
  delta_group_fw_cd: { group: 'Front Wing', position: -1, field: 'delta_cd' },
  delta_group_fw_cl: { group: 'Front Wing', position: -1, field: 'delta_cl' },
  delta_group_fw_cs: { group: 'Front Wing', position: -1, field: 'delta_cs' },
  delta_group_floor_bottom_cd: { group: 'Floor Bottom', position: -1, field: 'delta_cd' },
  delta_group_floor_bottom_cl: { group: 'Floor Bottom', position: -1, field: 'delta_cl' },
  delta_group_floor_bottom_cs: { group: 'Floor Bottom', position: -1, field: 'delta_cs' },
  delta_group_floor_top_cd: { group: 'Floor Top', position: -1, field: 'delta_cd' },
  delta_group_floor_top_cl: { group: 'Floor Top', position: -1, field: 'delta_cl' },
  delta_group_floor_top_cs: { group: 'Floor Top', position: -1, field: 'delta_cs' },
  delta_group_intake_cd: { group: 'Intake', position: -1, field: 'delta_cd' },
  delta_group_intake_cl: { group: 'Intake', position: -1, field: 'delta_cl' },
  delta_group_intake_cs: { group: 'Intake', position: -1, field: 'delta_cs' },
  delta_group_rw_cd: { group: 'Rear Wing', position: -1, field: 'delta_cd' },
  delta_group_rw_cl: { group: 'Rear Wing', position: -1, field: 'delta_cl' },
  delta_group_rw_cs: { group: 'Rear Wing', position: -1, field: 'delta_cs' },
  delta_group_susp_lf_arms_cd: { group: 'Susp LF Arms', position: -1, field: 'delta_cd' },
  delta_group_susp_lf_arms_cl: { group: 'Susp LF Arms', position: -1, field: 'delta_cl' },
  delta_group_susp_lf_arms_cs: { group: 'Susp LF Arms', position: -1, field: 'delta_cs' },
  delta_group_susp_lf_obd_cd: { group: 'Susp LF OBD', position: -1, field: 'delta_cd' },
  delta_group_susp_lf_obd_cl: { group: 'Susp LF OBD', position: -1, field: 'delta_cl' },
  delta_group_susp_lf_obd_cs: { group: 'Susp LF OBD', position: -1, field: 'delta_cs' },
  delta_group_susp_lr_arms_cd: { group: 'Susp LR Arms', position: -1, field: 'delta_cd' },
  delta_group_susp_lr_arms_cl: { group: 'Susp LR Arms', position: -1, field: 'delta_cl' },
  delta_group_susp_lr_arms_cs: { group: 'Susp LR Arms', position: -1, field: 'delta_cs' },
  delta_group_susp_lr_obd_cd: { group: 'Susp LR OBD', position: -1, field: 'delta_cd' },
  delta_group_susp_lr_obd_cl: { group: 'Susp LR OBD', position: -1, field: 'delta_cl' },
  delta_group_susp_lr_obd_cs: { group: 'Susp LR OBD', position: -1, field: 'delta_cs' },
  delta_group_susp_rf_arms_cd: { group: 'Susp RF Arms', position: -1, field: 'delta_cd' },
  delta_group_susp_rf_arms_cl: { group: 'Susp RF Arms', position: -1, field: 'delta_cl' },
  delta_group_susp_rf_arms_cs: { group: 'Susp RF Arms', position: -1, field: 'delta_cs' },
  delta_group_susp_rf_obd_cd: { group: 'Susp RF OBD', position: -1, field: 'delta_cd' },
  delta_group_susp_rf_obd_cl: { group: 'Susp RF OBD', position: -1, field: 'delta_cl' },
  delta_group_susp_rf_obd_cs: { group: 'Susp RF OBD', position: -1, field: 'delta_cs' },
  delta_group_susp_rr_arms_cd: { group: 'Susp RR Arms', position: -1, field: 'delta_cd' },
  delta_group_susp_rr_arms_cl: { group: 'Susp RR Arms', position: -1, field: 'delta_cl' },
  delta_group_susp_rr_arms_cs: { group: 'Susp RR Arms', position: -1, field: 'delta_cs' },
  delta_group_susp_rr_obd_cd: { group: 'Susp RR OBD', position: -1, field: 'delta_cd' },
  delta_group_susp_rr_obd_cl: { group: 'Susp RR OBD', position: -1, field: 'delta_cl' },
  delta_group_susp_rr_obd_cs: { group: 'Susp RR OBD', position: -1, field: 'delta_cs' },
  delta_group_tire_ramp_ls_cd: { group: 'Tire Ramp LS', position: -1, field: 'delta_cd' },
  delta_group_tire_ramp_ls_cl: { group: 'Tire Ramp LS', position: -1, field: 'delta_cl' },
  delta_group_tire_ramp_ls_cs: { group: 'Tire Ramp LS', position: -1, field: 'delta_cs' },
  delta_group_tire_ramp_rs_cd: { group: 'Tire Ramp RS', position: -1, field: 'delta_cd' },
  delta_group_tire_ramp_rs_cl: { group: 'Tire Ramp RS', position: -1, field: 'delta_cl' },
  delta_group_tire_ramp_rs_cs: { group: 'Tire Ramp RS', position: -1, field: 'delta_cs' },
  delta_group_restraints_cd: { group: 'Restraints', position: -1, field: 'delta_cd' },
  delta_group_restraints_cl: { group: 'Restraints', position: -1, field: 'delta_cl' },
  delta_group_restraints_cs: { group: 'Restraints', position: -1, field: 'delta_cs' },
  delta_group_ungrouped_cd: { group: 'Ungrouped', position: -1, field: 'delta_cd' },
  delta_group_ungrouped_cl: { group: 'Ungrouped', position: -1, field: 'delta_cl' },
  delta_group_ungrouped_cs: { group: 'Ungrouped', position: -1, field: 'delta_cs' }
}

type GroupForceData = {
  group: string
  delta_cd?: number
  delta_cl?: number
  delta_cs?: number
  cd?: number
  cl?: number
  cs?: number
  ref_cd?: number
  ref_cl?: number
  ref_cs?: number
  ref2_cd?: number
  ref2_cl?: number
  ref2_cs?: number
}

const GROUP_FORCE_COLUMNS = [{}]
// No !bg-transparent here: the PrimeReact Tailwind preset gives a scrollable <thead> a
// bg-slate-50 with no dark variant, which would show through and hide the light header text.
const GROUP_FORCE_HEADER_CLASS = `${CompactTableHeaderClassName} text-dark-blue dark:!bg-neutral-90 dark:!text-neutral-10`

const formatCoefficient = (row: GroupForceData, field: keyof GroupForceData) => {
  const isDelta = String(field).startsWith('delta_')
  let value = Number(row[field])
  if (field === 'delta_cd' && row['ref2_cd'] !== null && row['cd'] !== null) {
    value = Number(row['cd']) - Number(row['ref2_cd'])
  } else if (field === 'delta_cl' && row['ref2_cl'] !== null && row['cl'] !== null) {
    value = Number(row['cl']) - Number(row['ref2_cl'])
  } else if (field === 'delta_cs' && row['ref2_cs'] !== null && row['cs'] !== null) {
    value = Number(row['cs']) - Number(row['ref2_cs'])
  }

  if (Number.isNaN(value) || !Number.isFinite(value)) {
    return ''
  }

  // Sign coloring only carries meaning for deltas.
  const valueColor = !isDelta
    ? ''
    : value > 0.001
    ? 'text-red-600 dark:!text-red-400'
    : value < -0.001
    ? 'text-green-600 dark:!text-green-400'
    : ''
  return <span className={valueColor}>{value.toFixed(4)}</span>
}

const makeGroupForceData = (data: Record<string, any>): GroupForceData[] => {
  if (!data || !data.manifest?.schema?.columns || !data.result?.data_array) {
    return []
  }

  const groupForceData: GroupForceData[] = []

  data.manifest.schema.columns.forEach((column: any) => {
    const col = FIELD_TO_GROUP_MAP[column.name]
    if (col) {
      col.position = column.position
    }
  })

  Object.keys(GROUP_TO_FIELD_MAP).forEach(key => {
    const groupFields = GROUP_TO_FIELD_MAP[key]
    const groupDataItem: GroupForceData = {
      group: key,
      ref2_cd: null,
      ref2_cl: null,
      ref2_cs: null
    }
    groupFields.forEach(field => {
      const targetField = FIELD_TO_GROUP_MAP[field]
      if (targetField) {
        const position = targetField.position
        if (position >= 0 && position < data.result.data_array[0].length) {
          groupDataItem[targetField.field] = data.result.data_array[0][position]
        }
      }
    })
    groupForceData.push(groupDataItem)
  })

  return groupForceData
}

const mergeRef2Data = (
  groupForceData: GroupForceData[],
  ref2GroupForceData: GroupForceData[] | null
) => {
  if (!groupForceData) {
    return
  }

  // basically reset
  if (!ref2GroupForceData) {
    groupForceData.forEach(row => {
      row.ref2_cd = null
      row.ref2_cl = null
      row.ref2_cs = null
    })
  }
  groupForceData?.forEach(row => {
    const ref2Row = ref2GroupForceData?.find(ref2Row => ref2Row.group === row.group)
    if (ref2Row) {
      row.ref2_cd = ref2Row.cd ?? null
      row.ref2_cl = ref2Row.cl ?? null
      row.ref2_cs = ref2Row.cs ?? null
    }
  })
}

const GroupForceAnalysis: FC = () => {
  const [{ loading: loadingGroupForceData }, getGroupForceData] = useGetGroupForceData()
  const [, getRef2GroupForceData] = useGetGroupForceData()
  const [projectRunSelection, setProjectRunSelection] = useState<Record<string, any>>({})
  const [selectedStates, setSelectedStates] = useState<string[]>([])
  const [selectedBaselines, setSelectedBaselines] = useState<string[]>([])
  const [filteredCases, setFilteredCases] = useState<Record<string, any>[]>([])
  const [selectedCaseKey, setSelectedCaseKey] = useState<string | null>(null)
  const [ref2Value, setRef2Value] = useState<number | null>(null)
  const [groupForceData, setGroupForceData] = useState<GroupForceData[] | null>([])
  const ref2GroupForceData = useRef<GroupForceData[] | null>([])
  const [casesCacheVersion, setCasesCacheVersion] = useState(0)
  const casesRef = useRef<Record<string, any>[]>([])
  const ref2FetchTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const ref2InputRef = useRef<InputNumber>(null)
  const ref2NativeInputRef = useRef<HTMLInputElement>(null)
  const skipNextRef2DebounceRef = useRef(false)
  const [loadingRef2, setLoadingRef2] = useState(false)
  const [panelCollapsed, setPanelCollapsed] = useState(false)
  const [charts, setCharts] = useState<GroupForceChartConfig[][]>(() => {
    const savedCharts = localStorage.getItem(KEY_GROUP_FORCE_CHARTS)
    if (savedCharts) {
      // Charts used to hold a single `field`; widen anything saved before multi-select.
      return JSON.parse(savedCharts).map((row: any[]) =>
        row.map(chart => ({
          key: chart.key,
          fields: chart.fields ?? (chart.field ? [chart.field] : [])
        }))
      )
    }
    return [[{ key: new Date().getTime(), fields: ['delta_cd'] }]]
  })

  const handleAddRight = (rowIndex: number, colIndex: number) => {
    if (!charts[rowIndex]) {
      return
    }
    if (charts[rowIndex].length >= 3 || colIndex >= 2) {
      return
    }
    setCharts(prevCharts => {
      const newCharts = prevCharts.map(row => [...row])
      newCharts[rowIndex].splice(colIndex + 1, 0, {
        key: new Date().getTime(),
        fields: ['delta_cd']
      })
      return newCharts
    })
  }

  const handleAddUnder = (rowIndex: number) => {
    if (charts.length >= 3 || rowIndex >= 2) {
      return
    }
    setCharts(prevCharts => {
      const newCharts = prevCharts.map(row => [...row])
      newCharts.splice(rowIndex + 1, 0, [{ key: new Date().getTime(), fields: ['delta_cd'] }])
      return newCharts
    })
  }

  const handleRemove = (rowIndex: number, colIndex: number) => {
    if (rowIndex >= charts.length) {
      return
    }
    if (colIndex >= charts[rowIndex].length) {
      return
    }
    if (charts[rowIndex].length === 1 && charts.length === 1) {
      return
    }
    setCharts(prevCharts => {
      const newCharts = prevCharts.map(row => [...row])
      newCharts[rowIndex].splice(colIndex, 1)
      if (newCharts[rowIndex].length === 0) {
        newCharts.splice(rowIndex, 1)
      }
      return newCharts
    })
  }

  const loadRef2GroupForceData = (caseId: number) => {
    if (caseId === Number(selectedCaseKey)) {
      toast.error('Ref 2 cannot be the same as the selected case.')
      return
    }
    setLoadingRef2(true)
    getRef2GroupForceData({ caseId } as any)
      .then(response => {
        const total_row_count = response.data.manifest.total_row_count
        if (total_row_count === 0) {
          toast.error('No Ref 2 group force data found for the selected case.')
          ref2GroupForceData.current = null
          setGroupForceData(
            groupForceData?.map(row => ({
              ...row,
              ref2_cd: null,
              ref2_cl: null,
              ref2_cs: null
            }))
          )
          return
        }
        ref2GroupForceData.current = makeGroupForceData(response.data)
        const newGroupForceData = groupForceData?.map(row => {
          const ref2Row = ref2GroupForceData.current?.find(ref2Row => ref2Row.group === row.group)
          const newRow = ref2Row
            ? {
                ...row,
                ref2_cd: ref2Row.cd ?? null,
                ref2_cl: ref2Row.cl ?? null,
                ref2_cs: ref2Row.cs ?? null
              }
            : { ...row }
          return newRow
        })
        setGroupForceData(newGroupForceData)
      })
      .catch(error => {
        console.error('Error fetching Ref 2 group force data:', error)
        toast.error('Error fetching Ref 2 group force data.')
        ref2GroupForceData.current = null
      })
      .finally(() => {
        setLoadingRef2(false)
      })
  }

  const scheduleRef2GroupForceDataLoad = (caseId: number | null, delay = 1000) => {
    const resetRef2 = () => {
      setLoadingRef2(false)
      ref2GroupForceData.current = null
      setGroupForceData(
        groupForceData?.map(row => ({
          ...row,
          ref2_cd: null,
          ref2_cl: null,
          ref2_cs: null
        }))
      )
    }

    if (ref2FetchTimerRef.current) {
      clearTimeout(ref2FetchTimerRef.current)
      ref2FetchTimerRef.current = null
    }

    if (caseId === null) {
      resetRef2()
      return
    }

    ref2FetchTimerRef.current = setTimeout(() => {
      if (ref2NativeInputRef.current?.value === '') {
        resetRef2()
        return
      }
      loadRef2GroupForceData(Number(ref2NativeInputRef.current?.value))
      ref2FetchTimerRef.current = null
    }, delay)
  }

  const loadRef2GroupForceDataImmediately = () => {
    if (ref2FetchTimerRef.current) {
      clearTimeout(ref2FetchTimerRef.current)
      ref2FetchTimerRef.current = null
    }

    // Reset Ref 2 data if no value is present
    if (!ref2NativeInputRef.current?.value) {
      ref2GroupForceData.current = null
      setGroupForceData(
        groupForceData?.map(row => ({
          ...row,
          ref2_cd: null,
          ref2_cl: null,
          ref2_cs: null
        }))
      )
      return
    }
    const caseId = Number(ref2NativeInputRef.current?.value)
    if (!Number.isFinite(caseId)) {
      scheduleRef2GroupForceDataLoad(null)
      return
    }

    loadRef2GroupForceData(caseId)
  }

  useEffect(() => {
    return () => {
      if (ref2FetchTimerRef.current) {
        clearTimeout(ref2FetchTimerRef.current)
      }
    }
  }, [])

  useEffect(() => {
    if (!selectedCaseKey) {
      setGroupForceData([])
      return
    }
    getGroupForceData({ caseId: selectedCaseKey } as any)
      .then(response => {
        const tmp = makeGroupForceData(response.data)
        mergeRef2Data(tmp, ref2GroupForceData.current)
        setGroupForceData(tmp)
      })
      .catch(error => {
        console.error('Error fetching group force data:', error)
        toast.error('Error fetching group force data.')
        setGroupForceData([])
      })
  }, [selectedCaseKey])

  const filterCases = () => {
    const selectedProjects = new Set<string>()
    const projectsWithAllRunsSelected = new Set<string>()
    const selectedRuns = new Set<string>()
    Object.entries(projectRunSelection).forEach(([key, value]) => {
      if (!value?.checked) return
      const [project, run] = key.split(KEY_DELIMITER)
      selectedProjects.add(project)
      if (run) {
        selectedRuns.add(key)
      } else {
        projectsWithAllRunsSelected.add(project)
      }
    })

    setFilteredCases(
      casesRef.current.filter(caseRow => {
        const project = String(caseRow.project || '')
        const run = String(caseRow.run || '')
        if (!selectedProjects.has(project)) return false
        if (
          !projectsWithAllRunsSelected.has(project) &&
          !selectedRuns.has(`${project}${KEY_DELIMITER}${run}`)
        )
          return false
        if (selectedStates.length > 0 && !selectedStates.includes(String(caseRow.state_name)))
          return false
        return (
          selectedBaselines.length === 0 || selectedBaselines.includes(String(caseRow.baseline_run))
        )
      })
    )
  }

  useEffect(() => {
    filterCases()
  }, [projectRunSelection, selectedStates, selectedBaselines, casesCacheVersion])

  const getCaseKey = (caseRow: Record<string, any>) => caseRow.gm_id
  useEffect(() => {
    const nextCase = filteredCases[0]
    setSelectedCaseKey(nextCase ? getCaseKey(nextCase) : null)
    setRef2Value(
      nextCase?.ref_gm_id_2nd === null || nextCase?.ref_gm_id_2nd === undefined
        ? null
        : Number(nextCase.ref_gm_id_2nd)
    )
  }, [filteredCases])

  const selectedCase = filteredCases.find(caseRow => getCaseKey(caseRow) === selectedCaseKey)
  const caseOptions = filteredCases.map(caseRow => ({
    label: `${caseRow.gm_id} (${caseRow.project} / ${caseRow.run} / ${caseRow.state_name})`,
    value: caseRow.gm_id
  }))

  return (
    <div className="flex items-stretch space-x-2 flex-1 min-h-0">
      {/* Collapsed panel keeps its height in the flow — the rest of the page has no height of its own. */}
      <div
        aria-hidden={panelCollapsed}
        className={`flex flex-col items-stretch space-y-2 pb-2 pt-0 ${
          panelCollapsed ? 'w-0 overflow-hidden pointer-events-none' : ''
        }`}>
        <ProjectRunSelector
          loadingHeadlineData={false}
          showFilter={true}
          storageScope="group-force-analysis"
          baselineSourceData={casesRef.current}
          onProjectRunLoaded={rows => {
            casesRef.current = rows.map((row: any) => {
              if (!Array.isArray(row)) {
                return row
              }
              return {
                project: row[0],
                run: row[1],
                state_name: row[2],
                project_desc: row[3],
                run_desc: row[4],
                gm_id: row[5],
                ref_gm_id: row[6],
                baseline_run: row[7]
              }
            })
            setCasesCacheVersion(version => version + 1)
          }}
          onProjectRunSelectionChanged={selection => {
            setProjectRunSelection(selection)
          }}
          onStateSelectionChanged={states => setSelectedStates(states)}
          onBaselineSelectionChanged={baselines => setSelectedBaselines(baselines)}
          onReset={() => {
            casesRef.current = []
            setFilteredCases([])
            setCasesCacheVersion(version => version + 1)
            setProjectRunSelection({})
            setSelectedStates([])
            setSelectedBaselines([])
            setSelectedCaseKey(null)
          }}
        />
      </div>
      <button
        className="shrink-0 w-5 flex flex-col items-center pt-2 hover:bg-blue-500/10 transition-colors border-r border-solid border-neutral-200 dark:border-neutral-600"
        onClick={() => setPanelCollapsed(collapsed => !collapsed)}
        title={panelCollapsed ? 'Expand panel' : 'Collapse panel'}
        aria-label={panelCollapsed ? 'Expand panel' : 'Collapse panel'}>
        <i
          className={`pi ${
            panelCollapsed ? 'pi-chevron-right' : 'pi-chevron-left'
          } text-[0.6rem] text-neutral-500 dark:text-neutral-400`}
        />
      </button>
      <div className="flex basis-0 grow items-stretch space-x-2 ">
        <div className="flex flex-col basis-[640px] items-stretch space-y-2 rounded-md p-4 border border-gray-300 shrink-0">
          <div className="flex items-stretch gap-2 basis-[80px] rounded-md p-4 border border-gray-300 ">
            <div className="flex flex-col items-stretch basis-0 grow">
              <label>Case</label>
              <Dropdown
                value={selectedCaseKey}
                options={caseOptions}
                placeholder="Select a case"
                className="w-full"
                filter
                filterMatchMode="startsWith"
                filterBy="label"
                onChange={async event => {
                  setSelectedCaseKey(event.value)
                }}
                pt={{
                  input: {
                    className: '!py-2'
                  }
                }}
              />
            </div>
            <div className="flex flex-col items-stretch basis-[100px]">
              <label>Ref</label>
              <InputText
                value={String(selectedCase?.ref_gm_id || '')}
                disabled
                readOnly
                className="w-[100px]"
              />
            </div>
            <div className="flex flex-col items-stretch max-w-[100px] relative">
              <label>Ref 2</label>
              <InputNumber
                ref={ref2InputRef}
                inputRef={ref2NativeInputRef}
                value={ref2Value}
                onValueChange={event => {
                  setRef2Value(event.value)
                }}
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    skipNextRef2DebounceRef.current = true
                    if (Number(ref2Value) === Number(selectedCaseKey)) {
                      toast.error('Ref 2 cannot be the same as the selected case.')
                      return
                    }
                    loadRef2GroupForceDataImmediately()
                    return
                  }
                  if (event.key === '.') {
                    event.preventDefault()
                    event.stopPropagation()
                    return
                  }
                  scheduleRef2GroupForceDataLoad(undefined)
                }}
                min={0}
                useGrouping={false}
                className="max-w-[100px]"
                showButtons={false}
                pt={{
                  input: {
                    root: {
                      className: 'max-w-[100px] pr-7'
                    }
                  }
                }}
              />
              {loadingRef2 && (
                <div className="pointer-events-none absolute right-2 bottom-3 z-10 flex h-4 w-4 items-center justify-center">
                  <i className="pi pi-spin pi-spinner text-sm text-gm-blue dark:text-light-blue"></i>
                </div>
              )}
              {!loadingRef2 && (
                <div
                  className="absolute right-2 bottom-3 z-10 flex h-4 w-4 items-center justify-center cursor-pointer"
                  onClick={() => {
                    setRef2Value(null)
                    ref2NativeInputRef.current.value = ''
                    scheduleRef2GroupForceDataLoad(undefined)
                  }}>
                  <i className="pi pi-times text-sm text-neutral-60 dark:text-neutral-20 "></i>
                </div>
              )}
            </div>
          </div>
          <div className="basis-0 grow">
            <DataTable
              value={groupForceData || []}
              loading={loadingGroupForceData}
              scrollable
              scrollHeight="flex"
              size="small"
              emptyMessage="Select a case to view group force data."
              className="h-full"
              pt={{
                loadingOverlay: {
                  className:
                    'bg-white/80 dark:bg-neutral-90/80 flex items-center justify-center z-10'
                },
                loadingIcon: {
                  className: '!text-gm-blue dark:!text-light-blue text-2xl'
                },
                bodyRow: {
                  className: 'table-row'
                }
              }}>
              <Column
                field="group"
                header="Group"
                headerClassName={GROUP_FORCE_HEADER_CLASS}
                bodyClassName="id-cell"
                style={{ minWidth: '10rem' }}
              />
              <Column
                field="delta_cd"
                header="Delta CD"
                headerClassName={GROUP_FORCE_HEADER_CLASS}
                bodyClassName="text-right"
                body={row => formatCoefficient(row, 'delta_cd')}
              />
              <Column
                field="delta_cl"
                header="Delta CL"
                headerClassName={GROUP_FORCE_HEADER_CLASS}
                bodyClassName="text-right"
                body={row => formatCoefficient(row, 'delta_cl')}
              />
              <Column
                field="delta_cs"
                header="Delta CS"
                headerClassName={GROUP_FORCE_HEADER_CLASS}
                bodyClassName="text-right"
                body={row => formatCoefficient(row, 'delta_cs')}
              />
              <Column
                field="cd"
                header="CD"
                headerClassName={GROUP_FORCE_HEADER_CLASS}
                bodyClassName="text-right"
                body={row => formatCoefficient(row, 'cd')}
              />
              <Column
                field="cl"
                header="CL"
                headerClassName={GROUP_FORCE_HEADER_CLASS}
                bodyClassName="text-right"
                body={row => formatCoefficient(row, 'cl')}
              />
              <Column
                field="cs"
                header="CS"
                headerClassName={GROUP_FORCE_HEADER_CLASS}
                bodyClassName="text-right"
                body={row => formatCoefficient(row, 'cs')}
              />
            </DataTable>
          </div>
        </div>
        <div className="flex flex-col items-stretch gap-2 basis-0 grow">
          {charts.map((rowItem, rowIndex) => {
            return (
              <div key={rowIndex} className="flex items-stretch gap-2 basis-0 grow">
                {rowItem.map((colItem, colIndex) => (
                  <GroupForceChartPanel
                    key={charts[rowIndex][colIndex].key}
                    groupForceData={groupForceData}
                    rowIndex={rowIndex}
                    colIndex={colIndex}
                    charts={charts}
                    onAddRight={handleAddRight}
                    onAddUnder={handleAddUnder}
                    onRemove={handleRemove}
                    onMonitorChange={(rowIndex, colIndex, monitors) => {
                      setCharts(prevCharts => {
                        const newCharts = [...prevCharts]
                        newCharts[rowIndex][colIndex].fields = monitors
                        localStorage.setItem(KEY_GROUP_FORCE_CHARTS, JSON.stringify(newCharts))
                        return newCharts
                      })
                    }}
                  />
                ))}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default GroupForceAnalysis
